import { Component, OnInit } from '@angular/core';
import { ResultData } from 'src/app/_models/ResultData';
import { CurriculumService } from 'src/app/_services/curricula.service';

@Component({
  selector: 'app-curriculum-index',
  templateUrl: './curriculum-index.component.html',
  styleUrls: ['./curriculum-index.component.css']
})
export class CurriculumIndexComponent implements OnInit {
  curricular =[]
  dtOptions: DataTables.Settings = {};
  loading = false
  constructor( private curriculumService:CurriculumService) { }

    ngOnInit(): void {
      this.loading=true
      this.dtOptions = {
        pagingType: 'full_numbers'
       };
      this.loadFacts()
    }


    loadFacts(): void {
      this.loading = true;
      this.curriculumService.getCurricula().subscribe({
        next: (data:ResultData) => {
          this.curricular = data.rs.data
            this.loading = false;
        },
        error: (err) => {
          console.error('Error loading facts', err);
          this.loading = false;
        }
      });
    }
  }
